import {
  FEATURE_CREDITS_API_KEYS,
  LICENSE_TYPES,
  SUBSCRIPTIONS_API_KEYS,
} from "features/MySubscriptions/constants/MySubscriptions.constants";
import { useCreditDetails } from "features/MySubscriptions/utils/useCreditDetails";

export const useCheckZoomLicenseActive = () => {
  const {
    data: { [FEATURE_CREDITS_API_KEYS.total_credits]: totalCredits } = {},
  } = useCreditDetails({
    params: {
      [SUBSCRIPTIONS_API_KEYS.feature_key]: LICENSE_TYPES.EXLY_ZOOM,
    },
  });
  const creditsAvailable = totalCredits > 0;
  return creditsAvailable;
};
